export default "__VITE_ASSET__ZWRfXfcN__"